import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import cx from 'classnames';
import _ from 'lodash';
import { Screen } from 'src/components';
import { LINKS } from 'src/constants';
import MobileSipTransactionsSuccess from './mobileSipTransactionsSuccess';
import DesktopSipTransactionsSuccess from './desktopSipTransactionsSuccess';
import styles from './_sipTransactionsSuccess.module.scss';

class SipTransactionsSuccess extends Component {
  componentDidMount() {
    setTimeout(() => {
      const { status } = this.props;
      const isSuccess = status === 'success';
      if (isSuccess) window.location.href = LINKS.SURVEY_LINK;
    }, 3000);
  }

  render() {
    const { checkout, status, reason } = this.props;
    let checkoutDetail = checkout?.checkoutPaymentSip || {};
    if (_.isEmpty(checkoutDetail)) checkoutDetail = checkout?.checkoutDetail || {};

    return (
      <>
        <Screen>
          <div className={cx(styles['sip-transactions-success'])}>
            <div className={styles['mobile']}>
              <MobileSipTransactionsSuccess
                checkoutDetail={checkoutDetail}
                status={status}
                reason={reason}
              />
            </div>
            <div className={styles['desktop']}>
              <DesktopSipTransactionsSuccess
                checkoutDetail={checkoutDetail}
                status={status}
                reason={reason}
              />
            </div>
          </div>
        </Screen>
      </>
    );
  }
}

export default withRouter(SipTransactionsSuccess);
